// Shared validation utilities for booking forms

const ID_FORMAT_PATTERNS = {
  aadhaar: /^\d{12}$/,
  passport: /^[A-Z]\d{7}$/i,
  driving_licence: /^[A-Z]{2}\d{2}\s?\d{4}\d{7}$/i,
  voter_id: /^[A-Z]{3}\d{7}$/i,
  pan: /^[A-Z]{5}\d{4}[A-Z]$/i,
}

const ID_FORMAT_HINTS = {
  aadhaar: '12 digits (e.g. 123456789012)',
  passport: 'Letter + 7 digits (e.g. A1234567)',
  driving_licence: 'State code + digits (e.g. DL01 20190001234)',
  voter_id: '3 letters + 7 digits (e.g. ABC1234567)',
  pan: '5 letters + 4 digits + 1 letter (e.g. ABCDE1234F)',
}

export const validateIdNumber = (idType, idNumber) => {
  if (!idType || idType === 'none') return null
  if (!idNumber || idNumber.trim().length === 0) return 'ID number is required'
  const pattern = ID_FORMAT_PATTERNS[idType]
  if (pattern && !pattern.test(idNumber.trim())) {
    return `Invalid format — ${ID_FORMAT_HINTS[idType]}`
  }
  return null
}

export const getIdFormatHint = (idType) => {
  return ID_FORMAT_HINTS[idType] || null
}

// Indian mobile: 10 digits starting with 6-9
const PHONE_PATTERN = /^[6-9]\d{9}$/

export const validatePhone = (phone) => {
  if (!phone || phone.trim().length === 0) return 'Phone number is required'
  const cleaned = phone.replace(/[\s\-+]/g, '')
  // Allow +91 prefix
  const digits = cleaned.startsWith('91') && cleaned.length === 12 ? cleaned.slice(2) : cleaned
  if (!PHONE_PATTERN.test(digits)) {
    return 'Enter a valid 10-digit Indian mobile number'
  }
  return null
}

export const validateEmail = (email) => {
  if (!email || email.trim().length === 0) return 'Email is required'
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
    return 'Enter a valid email address'
  }
  return null
}

export const validateName = (name) => {
  if (!name || name.trim().length === 0) return 'Name is required'
  if (name.trim().length < 2) return 'Name must be at least 2 characters'
  if (name.trim().length > 100) return 'Name must be 100 characters or less'
  return null
}

export const validateAge = (age) => {
  const num = Number(age)
  if (age === '' || age === null || age === undefined) return 'Age is required'
  if (Number.isNaN(num) || num < 0 || num > 120) return 'Age must be between 0 and 120'
  if (!Number.isInteger(num)) return 'Age must be a whole number'
  return null
}

export const validateGuestDetails = (guests) => {
  const errors = {}
  let hasErrors = false

  guests.forEach((g, i) => {
    const errs = {}
    const nameErr = validateName(g.full_name)
    if (nameErr) errs.full_name = nameErr

    const ageErr = validateAge(g.age)
    if (ageErr) errs.age = ageErr

    if (!g.gender) errs.gender = 'Gender is required'

    const idErr = validateIdNumber(g.id_type, g.id_number)
    if (idErr) errs.id_number = idErr

    if (Object.keys(errs).length > 0) {
      errors[i] = errs
      hasErrors = true
    }
  })

  return { errors, hasErrors }
}
